<template>
  <div>
    <br />
    <b-card no-body class="text-center" id="card">
      <QuestionComponent
        v-for="(question ) in filteredQuestList"
        :key="question.question_id"
        :keyId="question.question_id"
        :question="question"
      />
    </b-card>
  </div>
</template> 

<script>
import QuestionComponent from "./Question.vue";
import { getAllQAs } from "./../../api/conection";

export default {
  name: "QuestionList",
  props: {
    questionList: {
      type: Array,
      default: []
    },
    filter: {
      type: String,
      default: ""
    }
  },
  components: {
    QuestionComponent
  },
  mounted() {
    getAllQAs()
      .then(response => {
        if (response.status === 200)
          this.$store.dispatch("setQAsAction", response.body);
      })
      .catch(err => {
        console.log(err);
      });
  },
  computed: {
    filteredQuestList() {
      //console.log(this.filter);
      return this.questionList.filter(qst => {
        if (!this.filter) {
          return true;
        } else {
          const ctgs = qst.categories.map(cat => cat.name);
          //console.log('categorias',ctgs);
          //console.log('filter',this.filter);
          return ctgs.includes(this.filter);
        }
      });
    }
  }
};
</script>

<style>
#card {
  height: 100%;
  width: 100vw;
}
